import React, { Component } from "react";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import AutoComplete from "../../../../../../components/form/AutoComplete";
import DatePicker from "../../../../../../components/form/DateTime";
import Checkbox from "../../../../../../components/form/Checkbox";
import Input from "../../../../../../components/form/Input";
import Select from "../../../../../../components/form/Select";
import CroField from "../../../generalForm/CroField";
import CroCheckbox from "../../../generalForm/CroCheckbox";
import CroPriceField from "../../../generalForm/CroPriceField";
import CroMunicipality from "../../../generalForm/CroMunicipality";
import CroCountry from "../../../generalForm/CroCountry";
import {
  CroAddButton,
  CroRemoveButton,
} from "../../../generalForm/CroIconButtons";
import { isBeforeOrAtDay } from "../../../../CroUtils";
import { getRealtyType, validateRealtyOwnership } from "../../../../CroActions";
import * as V from "../../../../../../utils/formValidation";
import {isObject, isNil, isArray, isEmpty, noop} from "lodash";
import {
  RealtyTypeRaw,
  StatementFileType,
  RealtyTypeSelect,
  RealtyTypeSelectRaw,
  RealtyTypeFilters,
  StatementStateRaw,
} from "../../../../enum";
import H from "../../../../helpEnum";
import Help from "../../../Help";
import { ReduxCheckbox } from "../../../../../../components/form/Checkbox";
import CroFiles from "../../../generalForm/CroFiles";
import { ItemNumber } from "./itemRenumber";
import { change } from "redux-form";

const req = (typeObj, allowedTypes) => {
  if (!isObject(typeObj)) return [];
  return allowedTypes.includes(typeObj.type) ? [V.required] : [];
};

const incl = (typeObj, allowedTypes) => {
  if (!isObject(typeObj)) return false;
  return allowedTypes.includes(typeObj.type);
};

class Realties extends Component {
  state = {
    validations: {},
  };

  addItem = () => {
    const { fields } = this.props;
    fields.push({ itemOrder: fields.length + 1 });
  };

  removeItem = (index) => {
    const { fields, form, dispatch, selector } = this.props;
    const arrayName = fields.name;
    const current = selector(arrayName) || [];
    const next = current
        .filter((_, i) => i !== index)
        .map((item, idx) => ({ ...item, itemOrder: idx + 1 }));
    dispatch(change(form, arrayName, next));
  };

  changeRealtySelect = (item) => (e) => {
    const { change, selector } = this.props;

    this.setTypeGroup(item, e);

    const updateItem = (typeValue) => {
      const currentValue = selector(`${item}`);
      change(`${item}`, { ...(currentValue || {}), type: typeValue, typeGroup: e });
    };

    if (
        [RealtyTypeSelectRaw.PRAVO_STAVBY, RealtyTypeSelectRaw.OTHER].includes(e)
    ) {
      getRealtyType(e)
          .then((result) => updateItem(result.items[0]))
          .catch(() => updateItem(null));
    } else {
      updateItem("");
    }
  };

  applyRealtyFilter = (item) => (array) => {
    return array.filter((r) =>
      Object.keys(RealtyTypeFilters[item]).includes(r.type),
    );
  };

  setTypeGroup = (item, type) => {
    const { change, dispatch, form } = this.props;
    this.setState({ [item]: type });
    dispatch(change(form, `${item}.typeGroup`, type));
  }

  changeCadastre = (item, check) => () => {
    const { change } = this.props;
    change(`${item}.isFromCadastre`, check);
    change(`${item}.hasFileRef`, false);
    change(`${item}.type`, undefined);
    change(`${item}.typeGroup`, undefined);
    this.setState({ [item]: undefined });
  };

  validateOwnership = async (item, cadastreChange) => {
    const { selector, disabled, dispatch } = this.props;

    if(disabled) return;

    const lv = selector(`${item}.lv`);
    const cadastre = cadastreChange ? cadastreChange : selector(`${item}.cadastre`);
    const parcelNumber = selector(`${item}.parcelNumber`);
    const official = selector("statementOfficial");

    if (!isNil(lv) && !isNil(cadastre) && cadastre.code && !isNaN(lv)) {
      const validity = await validateRealtyOwnership(official.firstName, official.lastName, official.birthDate, lv, cadastre.code, parcelNumber, dispatch);
      if(validity) {
        let validation = {};
        if(!validity.realtyValid) {
          validation.message = "Uvedené údaje se nenacházejí v evidenci katastru nemovitostí";
          validation.valid = false;
        } else if(!validity.ownerMatch) {
          validation.message = "Uvedené údaje neodpovídají vlastníkovi nemovitosti";
          validation.valid = false;
        } else {
          validation.message = "Vlastnictví nemovitosti bylo ověřeno";
          validation.valid = true;
        }
        this.setState({ validations: { ...this.state.validations, [item]: validation } });
      }
    } else {
      this.setState({ validations: { ...this.state.validations, [item]: undefined } });
    }
  }

  getHint(hasFileRef, isFromCadastre) {
    if (isFromCadastre) {
      return "V případě importu z katastru nemovitostí se údaje o nemovitosti vyplní automaticky.";
    } else if (hasFileRef) {
      return "Pokud je oznámení o nemovitostech podáno formou datového souboru, není možné zadat údaje nemovitosti ručně.";
    } else if (isFromCadastre === false) {
      return "V případě individuálního zadání je nutné vyplnit všechny údaje o nemovitosti.";
    }
  }

  componentDidMount() {
    const { fields, selector, ingoing, disabled, change } = this.props;

    fields.forEach((item) => {
      const typeGroup = selector(`${item}.typeGroup`);
      const s = selector(`${item}.type`);

      if (!isNil(typeGroup) && isNil(s)) {
        this.setState({ [item]: typeGroup });
      } else {
        const select = isNil(s)
            ? null
            : Object.keys(RealtyTypeFilters).filter(
                (realtySelect) => !isNil(RealtyTypeFilters[realtySelect][s.type]),
            );

        if (isArray(select)) {
          if (!isEmpty(select)) {
            this.setTypeGroup(item, select[0]);
          } else {
            this.setTypeGroup(item, s.type);
          }
        } else {
          const id = selector(`${item}.id`);
          if (!isNil(id)) {
            this.setTypeGroup(item, RealtyTypeRaw.OTHER);
          }
        }
      }

      if (ingoing && !disabled) {
        change(`${item}.hasFileRef`, false);
      }
    });
  }

  render() {
    const {
      fields,
      disabled,
      noPublicLogged,
      dos,
      selector,
      ingoing,
      ongoing,
      workingPositions,
      t,
      point3,
      outgoing,
      dispatch,
      submitFailed,
      form,
      creationDate,
      versionChangedClass
    } = this.props;

    return (
      <div className="cro-array-container">
        {fields.map((item, index) => {
          const selectedType = this.state[item];
          const s = selector(`${item}.type`);
          const hasFileRef = selector(`${item}.hasFileRef`);
          const isFromCadastre = selector(`${item}.isFromCadastre`);
          const isOldStatement =
            !isNil(creationDate) &&
            isBeforeOrAtDay(creationDate, new Date("2019-05-31"));
          const cadastreMunicipality = selector(`${item}.cadastreMunicipality`);
          const isOther = incl(s, [RealtyTypeRaw.OTHER]);
          const reqUndergroud = req(s, []);
          const reqK = isOther ? [] : [V.required];
          const reqP = req(s, [
            RealtyTypeRaw.BUDOVA_S_POPISNYM,
            RealtyTypeRaw.BUDOVA_S_EVIDENCNIM,
          ]);
          const notRequiredTypeOther = selectedType === RealtyTypeRaw.OTHER ? [] : [V.required];
          const sentStatement = selector("state") && selector("state") === StatementStateRaw.ACCEPT;

          const activeWorkingPositions = workingPositions ? workingPositions.filter(wp => !wp.end || new Date(wp.end) >= new Date()) : [];

          const validation = this.state.validations[item];
          const hint = this.getHint(hasFileRef, isFromCadastre);

          return (
            <>
              <div className="cro-array-item-hint">{hint}</div>
              <div key={index} className={`cro-array-item ${versionChangedClass ? versionChangedClass(item) : ""}`}>
              <ItemNumber index={index} />
              {!disabled && !hasFileRef && fields.length > 1 && (
                  <CroRemoveButton onClick={() => this.removeItem(index)} />
              )}
              <div className="cro-array-item-content">
                <div className="statementForm__arrayGrid">
                  <div className="statementForm__arrayFull">
                    <div className="checkbox-row">
                      {/* Cadastre checkboxes */}
                      {!isOldStatement && (
                        <>
                        <div className="checkbox">
                          <label className="title">
                            Import z katastru nemovitostí
                          </label>

                          <Checkbox
                              className={versionChangedClass ? versionChangedClass(`${item}.isFromCadastre`) : ""}
                              value={!isNil(isFromCadastre) && isFromCadastre}
                              onChange={this.changeCadastre(item, true)}
                              disabled={disabled}
                              aria-label="Import z katastru nemovitostí"
                          />
                          <span className="help-icon">
                            <Help
                              helpEnum={H[`${t}REALTY_IS_CADASTRE`].r}
                              disabled={disabled}
                            />
                          </span>
                        </div>
                        <div className="checkbox">
                          <label className="title">Individuální zadání</label>

                          <Checkbox
                              className={versionChangedClass ? versionChangedClass(`${item}.isFromCadastre`) : ""}
                              value={!isNil(isFromCadastre) && !isFromCadastre}
                              onChange={this.changeCadastre(item, false)}
                              disabled={disabled}
                              aria-label="Individuální zadání"
                          />
                          <span className="help-icon">
                            <Help
                              helpEnum={H[`${t}REALTY_IS_NOT_CADASTRE`].r}
                              disabled={disabled}
                            />
                          </span>
                        </div>
                      </>
                      )}

                      {/* File ref checkbox */}
                      {(!ingoing || isOldStatement) && (
                        <CroCheckbox
                          className={versionChangedClass ? versionChangedClass(`${item}.hasFileRef`) : ""}
                          labelStyle={{ flexBasis: "auto" }}
                          title="Oznámení o nemovitostech bylo podáno formou datového souboru"
                          name={`${item}.hasFileRef`}
                          component={ReduxCheckbox}
                          onChange={this.changeCadastre(item, undefined)}
                          disabled={disabled}
                          helpEnum={H[`${t}REALTY_HASFILEREF`].r}
                          helpIconStyle={{ marginLeft: -20 }}
                        />
                      )}
                    </div>
                  </div>

                  {/* From cadastre */}
                  {!hasFileRef &&
                    !isNil(isFromCadastre) &&
                    isFromCadastre && (
                      <>
                      <div className="statementForm__arrayFull">
                        {sentStatement && noPublicLogged && this.state[item] && this.state[item] != RealtyTypeRaw.OTHER && (
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.type`) : ""}
                              title="Druh nemovité věci"
                              name={`${item}.type`}
                              component={AutoComplete}
                              disabled={true}
                            />
                        )}

                        <div className="statementForm__arrayGrid">
                          {noPublicLogged && (
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.lv`) : ""}
                              title="Číslo LV"
                              name={`${item}.lv`}
                              component={Input}
                              disabled={disabled}
                              validate={[V.isNumeric, V.required]}
                              onBlur={() => this.validateOwnership(item)}
                              helpEnum={H[`${t}REALTY_LV`].r}
                            />
                          )}
                          {noPublicLogged && (
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.cadastre`) : ""}
                              title="Katastrální území"
                              name={`${item}.cadastre`}
                              component={AutoComplete}
                              disabled={disabled}
                              helpEnum={H[`${t}REALTY_CADASTRE`].r}
                              url="/api/ciselniky/katastralni-uzemi"
                              validate={[V.required, V.isDictionary]}
                              operation="STARTWITH"
                              dataSourceConfig={{ value: "id", text: "name" }}
                              searchBy="name"
                              onChange={(e) => this.validateOwnership(item, e)}
                            />
                          )}
                          {noPublicLogged && !ingoing && (
                            <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.acquisition`) : ""}
                                title="Způsob nabytí"
                                name={`${item}.acquisition`}
                                component={AutoComplete}
                                disabled={disabled}
                                url="/api/ciselniky/nabyti-nemovite-veci"
                                validate={[V.required, V.isDictionary]}
                                helpEnum={H[`${t}REALTY_ACQUISITION`].r}
                            />
                          )}

                          {noPublicLogged && (
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.parcelNumber`) : ""}
                              title="Parcelní číslo"
                              name={`${item}.parcelNumber`}
                              component={Input}
                              disabled={disabled}
                              helpEnum={H[`${t}REALTY_PARCEL_NUMBER`].r}
                              multiline
                              maxlen={1023}
                              onBlur={() => this.validateOwnership(item)}
                            />
                          )}

                          {!ingoing && !point3 && (
                              <CroPriceField
                                  className={versionChangedClass ? versionChangedClass(`${item}.price`) : ""}
                                  title="Pořizovací cena"
                                  name={`${item}.price`}
                                  component={Input}
                                  disabled={disabled}
                                  validate={[V.required, V.isNumeric]}
                                  helpEnum={H[`${t}REALTY_PRICE`].r}
                              />
                          )}

                          {!dos && !ingoing && !point3 && activeWorkingPositions && activeWorkingPositions.length > 1 && (
                              <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.acquisitionDate`) : ""}
                                  title="Datum nabytí"
                                  name={`${item}.acquisitionDate`}
                                  component={DatePicker}
                                  disabled={disabled}
                                  validate={[V.required]}
                              />
                          )}

                          {disabled && (
                            <>
                              <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.type`) : ""}
                                title="Druh nemovité věci"
                                name={`${item}.type`}
                                component={AutoComplete}
                                disabled={disabled}
                              />
                              {noPublicLogged && (
                                <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.cadastreMunicipality`) : ""}
                                  title="Obec katastrálního území"
                                  name={`${item}.cadastreMunicipality`}
                                  component={AutoComplete}
                                  disabled={disabled}
                                />
                              )}
                              {noPublicLogged && (
                                <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.orientationNumber`) : ""}
                                  title="Číslo popisné / evidenční"
                                  name={`${item}.orientationNumber`}
                                  component={Input}
                                  disabled={disabled}
                                />
                              )}
                            </>
                          )}
                          {noPublicLogged && (
                            <div className="statementForm__arrayFull">
                              <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.note`) : ""}
                                title="Poznámka"
                                name={`${item}.note`}
                                component={Input}
                                fullWidth
                                disabled={disabled}
                                multiline
                                helpEnum={H[`${t}REALTY_NOTE`].r}
                                maxlen={1000}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      {validation && (
                        <div className={`cro-array-item-validation ${!validation.valid ? 'invalid' : ''}`} >
                          {validation.message}
                        </div>
                      )}
                    </>
                    )}

                  {/* Realty type select */}
                  {!hasFileRef &&
                    (!isNil(isFromCadastre) && !isFromCadastre) && (
                      <div className="statementForm__arrayFull">
                        <label style={{ minWidth: 280 }} className={versionChangedClass ? versionChangedClass(`${item}.type`) : ""}>
                          <span className="title required">
                            Druh nemovité věci
                          </span>
                          <Select
                            style={{ width: "100%" }}
                            items={RealtyTypeSelect}
                            value={this.state[item]}
                            onChange={this.changeRealtySelect(item)}
                            meta={{}}
                            disabled={disabled}
                          />
                        </label>
                      </div>
                    )}

                  {/* Individual entry - ingoing */}
                  {!hasFileRef &&
                    !isNil(isFromCadastre) &&
                    !isFromCadastre &&
                    ingoing &&
                    !isNil(this.state[item]) && (
                      <div className="statementForm__arrayFull">
                        <div className="statementForm__arrayGrid">
                          {[
                            RealtyTypeSelectRaw.POZEMEK,
                            RealtyTypeSelectRaw.STAVBA,
                            RealtyTypeSelectRaw.JEDNOTKA,
                          ].includes(this.state[item]) && (
                            <div className="statementForm__arrayFull">
                              <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.type`) : ""}
                                title="Specifikace druhu"
                                name={`${item}.type`}
                                component={AutoComplete}
                                disabled={disabled}
                                fullWidth
                                url="/api/ciselniky/nemovite-veci"
                                applyFilter={this.applyRealtyFilter(
                                  this.state[item],
                                )}
                                validate={[V.required, V.isDictionary]}
                                helpEnum={H[`${t}REALTY_TYPE`].r}
                              />
                            </div>
                          )}
                          {noPublicLogged && (
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.cadastreMunicipality`) : ""}
                              title="Obec katastrálního území"
                              name={`${item}.cadastreMunicipality`}
                              component={AutoComplete}
                              disabled={disabled}
                              url="/api/ciselniky/mesta"
                              validate={[V.isDictionary, ...notRequiredTypeOther]}
                              operation="STARTWITH"
                              dataSourceConfig={{
                                value: "id",
                                text: "fullName",
                              }}
                            />
                          )}
                          {noPublicLogged && (
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.cadastre`) : ""}
                              title="Katastrální území"
                              name={`${item}.cadastre`}
                              component={AutoComplete}
                              disabled={
                                disabled ||
                                !cadastreMunicipality ||
                                !cadastreMunicipality.code
                              }
                              helpEnum={H[`${t}REALTY_CADASTRE`].r}
                              url={
                                cadastreMunicipality
                                  ? `/api/ciselniky/katastralni-uzemi/dohledat/${cadastreMunicipality.code}`
                                  : ""
                              }
                              validate={[V.isDictionary, ...notRequiredTypeOther]}
                              operation="STARTWITH"
                              dataSourceConfig={{ value: "id", text: "name" }}
                              searchBy="name"
                            />
                          )}
                          {noPublicLogged && (
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.lv`) : ""}
                              title="Číslo LV"
                              name={`${item}.lv`}
                              component={Input}
                              disabled={disabled}
                              validate={[V.isNumeric, ...notRequiredTypeOther]}
                              helpEnum={H[`${t}REALTY_LV`].r}
                            />
                          )}
                          {noPublicLogged && (
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.parcelNumber`) : ""}
                              title="Parcelní číslo"
                              name={`${item}.parcelNumber`}
                              component={Input}
                              disabled={disabled}
                              helpEnum={H[`${t}REALTY_PARCEL_NUMBER`].r}
                              validate={notRequiredTypeOther}
                              multiline
                              maxlen={1023}
                            />
                          )}
                          {noPublicLogged && (
                            <div className="statementForm__arrayFull">
                              <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.ownership`) : ""}
                                title="Vlastnictví"
                                name={`${item}.ownership`}
                                component={AutoComplete}
                                disabled={disabled}
                                fullWidth
                                url="/api/ciselniky/zpusob-vlastnictvi"
                                validate={[V.isDictionary]}
                                helpEnum={H[`${t}REALTY_OWNERSHIP`].r}
                              />
                            </div>
                          )}
                          {noPublicLogged && (
                            <CroCountry
                              className={versionChangedClass ? versionChangedClass(`${item}.country`) : ""}
                              title="Stát"
                              name={item}
                              disabled={disabled}
                              form={form}
                            />
                          )}
                          {noPublicLogged && (
                            <CroMunicipality
                              className={versionChangedClass ? versionChangedClass(`${item}.municipality`) : ""}
                              title="Obec"
                              name={item}
                              disabled={disabled}
                              form={form}
                            />
                          )}
                          {noPublicLogged && (
                            <CroField
                              className={versionChangedClass ? versionChangedClass(`${item}.orientationNumber`) : ""}
                              title="Číslo popisné / evidenční"
                              name={`${item}.orientationNumber`}
                              component={Input}
                              disabled={disabled}
                              validate={reqP}
                              helpEnum={H.HOUSE_NUMBER.r}
                            />
                          )}
                          {noPublicLogged && (
                            <div className="statementForm__arrayFull">
                              <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.note`) : ""}
                                title="Poznámka"
                                name={`${item}.note`}
                                component={Input}
                                fullWidth
                                disabled={disabled}
                                multiline
                                helpEnum={H[`${t}REALTY_NOTE`].r}
                                maxlen={1000}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                  {/* Not ingoing or old statement */}
                  {!hasFileRef && !isFromCadastre &&
                    (!ingoing || isOldStatement) &&
                    !isNil(this.state[item]) && (
                      <div className="statementForm__arrayFull">
                        <div className="statementForm__arrayGrid">
                          {[
                            RealtyTypeSelectRaw.POZEMEK,
                            RealtyTypeSelectRaw.STAVBA,
                            RealtyTypeSelectRaw.JEDNOTKA,
                          ].includes(this.state[item]) &&
                            !isOldStatement && (
                              <div className="statementForm__arrayFull">
                                <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.type`) : ""}
                                  title="Specifikace druhu"
                                  name={`${item}.type`}
                                  component={AutoComplete}
                                  disabled={disabled}
                                  fullWidth
                                  url="/api/ciselniky/nemovite-veci"
                                  applyFilter={this.applyRealtyFilter(
                                    this.state[item],
                                  )}
                                  validate={[V.required, V.isDictionary]}
                                  helpEnum={H[`${t}REALTY_TYPE`].r}
                                />
                              </div>
                            )}
                          {isOldStatement && (
                            <div className="statementForm__arrayFull">
                              <CroField
                                title="Druh nemovité věci"
                                name={`${item}.type`}
                                component={AutoComplete}
                                disabled={disabled}
                                fullWidth
                                url="/api/ciselniky/nemovite-veci"
                                validate={[V.required, V.isDictionary]}
                                helpEnum={H[`${t}REALTY_TYPE`].r}
                              />
                            </div>
                          )}

                          {(!ingoing || isOldStatement) && (
                            <div className="statementForm__arrayFull">
                              <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.acquisition`) : ""}
                                title="Způsob nabytí"
                                name={`${item}.acquisition`}
                                component={AutoComplete}
                                disabled={disabled}
                                fullWidth
                                url="/api/ciselniky/nabyti-nemovite-veci"
                                validate={[V.required, V.isDictionary]}
                                helpEnum={H[`${t}REALTY_ACQUISITION`].r}
                              />
                            </div>
                          )}

                          {(ongoing || outgoing) && !point3 && (
                            <CroPriceField
                              className={versionChangedClass ? versionChangedClass(`${item}.price`) : ""}
                              title="Pořizovací cena"
                              name={`${item}.price`}
                              component={Input}
                              disabled={disabled}
                              validate={[V.required, V.isNumeric]}
                              helpEnum={H[`${t}REALTY_PRICE`].r}
                            />
                          )}

                          {!dos && (
                            <>
                              {!point3 && activeWorkingPositions && activeWorkingPositions.length > 1 && (
                                <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.acquisitionDate`) : ""}
                                  title="Datum nabytí"
                                  name={`${item}.acquisitionDate`}
                                  component={DatePicker}
                                  disabled={disabled}
                                  validate={[V.required]}
                                />
                              )}

                              {isOther && noPublicLogged && (
                                <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.municipality`) : ""}
                                  title="Obec"
                                  name={`${item}.municipality`}
                                  component={AutoComplete}
                                  disabled={disabled}
                                  url="/api/ciselniky/mesta"
                                  validate={[...reqUndergroud, V.isDictionary]}
                                  dataSourceConfig={{
                                    value: "id",
                                    text: "fullName",
                                  }}
                                  operation="STARTWITH"
                                />
                              )}
                              {isOther && noPublicLogged && (
                                <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.street`) : ""}
                                  title="Ulice"
                                  name={`${item}.street`}
                                  component={Input}
                                  disabled={disabled}
                                  validate={reqUndergroud}
                                />
                              )}
                              {isOther && noPublicLogged && (
                                <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.zip`) : ""}
                                  title="PSČ"
                                  name={`${item}.zip`}
                                  component={Input}
                                  disabled={disabled}
                                  validate={reqUndergroud}
                                />
                              )}

                              {noPublicLogged && (
                                <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.cadastreMunicipality`) : ""}
                                  title="Obec katastrálního území"
                                  name={`${item}.cadastreMunicipality`}
                                  component={AutoComplete}
                                  disabled={disabled}
                                  url="/api/ciselniky/mesta"
                                  validate={[...notRequiredTypeOther, V.isDictionary]}
                                  operation="STARTWITH"
                                  dataSourceConfig={{
                                    value: "id",
                                    text: "fullName",
                                  }}
                                />
                              )}
                              {noPublicLogged && (
                                <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.cadastre`) : ""}
                                  title="Katastrální území"
                                  name={`${item}.cadastre`}
                                  component={AutoComplete}
                                  disabled={
                                    disabled ||
                                    !cadastreMunicipality ||
                                    !cadastreMunicipality.code
                                  }
                                  helpEnum={H[`${t}REALTY_CADASTRE`].r}
                                  url={
                                    cadastreMunicipality
                                      ? `/api/ciselniky/katastralni-uzemi/dohledat/${cadastreMunicipality.code}`
                                      : ""
                                  }
                                  validate={[...notRequiredTypeOther, V.isDictionary]}
                                  operation="STARTWITH"
                                  dataSourceConfig={{
                                    value: "id",
                                    text: "name",
                                  }}
                                  searchBy="name"
                                />
                              )}
                              {noPublicLogged && (
                                <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.lv`) : ""}
                                  title="Číslo LV"
                                  name={`${item}.lv`}
                                  component={Input}
                                  disabled={disabled}
                                  validate={[V.isNumeric, ...notRequiredTypeOther]}
                                  helpEnum={H[`${t}REALTY_LV`].r}
                                />
                              )}
                              {noPublicLogged && (
                                <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.parcelNumber`) : ""}
                                  title="Parcelní číslo"
                                  name={`${item}.parcelNumber`}
                                  component={Input}
                                  disabled={disabled}
                                  validate={notRequiredTypeOther}
                                  helpEnum={H[`${t}REALTY_PARCEL_NUMBER`].r}
                                  multiline
                                  maxlen={1023}
                                />
                              )}
                              {noPublicLogged && (
                                <CroField
                                  className={versionChangedClass ? versionChangedClass(`${item}.orientationNumber`) : ""}
                                  title="Číslo popisné / evidenční"
                                  name={`${item}.orientationNumber`}
                                  component={Input}
                                  disabled={disabled}
                                  validate={reqP}
                                  helpEnum={H.HOUSE_NUMBER.r}
                                />
                              )}
                            </>
                          )}

                          {noPublicLogged && (
                            <div className="statementForm__arrayFull">
                              <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.ownership`) : ""}
                                title="Vlastnictví"
                                name={`${item}.ownership`}
                                component={AutoComplete}
                                disabled={disabled}
                                fullWidth
                                url="/api/ciselniky/zpusob-vlastnictvi"
                                validate={[V.isDictionary]}
                                helpEnum={H[`${t}REALTY_OWNERSHIP`].r}
                              />
                            </div>
                          )}
                          {noPublicLogged && (
                            <div className="statementForm__arrayFull">
                              <CroField
                                className={versionChangedClass ? versionChangedClass(`${item}.note`) : ""}
                                title="Poznámka"
                                name={`${item}.note`}
                                component={Input}
                                fullWidth
                                disabled={disabled}
                                multiline
                                helpEnum={H[`${t}REALTY_NOTE`].r}
                                maxlen={1000}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                  {/* File upload */}
                  {hasFileRef && (
                    <div className="statementForm__arrayFull">
                      <CroFiles
                        publicLabel="Data pro veřejnost"
                        privateLabel="Data pro správce"
                        publicButtonLabel="Nahrát soubor pro veřejnost"
                        privateButtonLabel="Nahrát soubor pro správce"
                        privateTemplate="soupis_nemovitych_veci.xlsx"
                        publicTemplate="soupis_nemovitych_veci-verejnost.xlsx"
                        fileType={StatementFileType.REALITIES}
                        required
                        submitFailed={submitFailed}
                        disabled={disabled}
                        dispatch={dispatch}
                        form={form}
                        helpPrefix="REALTY"
                        t={t}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
            </>
          );
        })}
        {!disabled && (
          <div className="cro-array-add">
            <CroAddButton onClick={this.addItem} />
            <Help helpEnum={H.ADD_REMOVE_REALTIES.r} />
          </div>
        )}
      </div>
    );
  }
}

export default connect((state, { form }) => ({
  selector: (select) => formValueSelector(form)(state, select),
  submitFailed: state.form.statementForm.submitFailed || false,
}))(Realties);
